const styles = {
  paper: {
    p: 2,
    borderRadius: 2,
    border: '1px solid',
    borderColor: 'divider',
  },
  divider: {
    my: 2,
  },
  img: {
    width: 80,
    height: 80,
    borderRadius: 2,
    cursor: 'pointer',
    objectFit: 'cover',
    transition: '0.2s',
    '&:hover': {
      transform: 'scale(1.05)',
      boxShadow: 3,
    },
  },
  fab: {
    position: 'fixed',
    zIndex: 999,
    bottom: 20,
    right: 40,
  },
};

export default styles;
